// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  useAssignSetting,
  useSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FAIRE_DIRECT_SIGNUP_PHASE_2_250705 } from "@faire/web-api--source/indigofair/settings/FAIRE_DIRECT_SIGNUP_PHASE_2_250705";

export const useSettingFaireDirectSignupForVisitorXP = () => {
  return useSetting(FAIRE_DIRECT_SIGNUP_PHASE_2_250705, false);
};

export const useAssignSettingFaireDirectSignupForVisitorXP = () => {
  return useAssignSetting(FAIRE_DIRECT_SIGNUP_PHASE_2_250705);
};
